(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zerili-home-2026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zerili-browse-rail')) {
    customElements.define('zerili-browse-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.z26-browse-track');
        this.tools = this.querySelector('.z26-rail-tools');
        if (!this.track || !this.tools || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          this.tools.hidden = maximum < 4;
          this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 4;
          this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= maximum - 4;
        };
        this.tools.addEventListener('click', event => {
          const button = event.target.closest('button[data-direction]');
          if (!button) return;
          const card = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollTo({left: this.track.scrollLeft + Number(button.dataset.direction) * distance, behavior: 'instant'});
        }, options);
        this.track.addEventListener('scroll', this.update, { ...options, passive:true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zerili-product-stage"]) return;
  try {
    
  if (!customElements.get('zerili-product-stage')) {
    customElements.define('zerili-product-stage', class extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) this.initialize();
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule, { passive: true });
        this.motion.addEventListener('change', this.schedule);
        this.schedule();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        this.motion.removeEventListener('change', this.schedule);
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      initialize() {
        this.initialized = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const rect = this.querySelector('.zp-stage').getBoundingClientRect();
            const progress = this.motion.matches ? 1 : Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight * .65)));
            const distance = matchMedia('(max-width: 749px)').matches ? 70 : 220;
            this.style.setProperty('--spread', `${distance * (.25 + .75 * progress)}px`);
            this.style.setProperty('--fan-angle', `${9 * progress}deg`);
            this.style.setProperty('--lift', `${24 * (1 - progress)}px`);
          });
        };
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.packs = Array.from(this.querySelectorAll('.zp-stage__pack'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
        let side = 0;
        this.packs.forEach(pack => {
          pack.dataset.position = Number(pack.dataset.index) === index ? 'center' : side++ === 0 ? 'left' : 'right';
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
